import React from "react";

const Content = ({ children }) => (
  <div className="mt-4 content flex-grow-1 d-flex flex-column">{children}</div>
);

export default Content;
